export const colorWithOpacity = (color: string, opacity: number) => {
  // eg. 0.5 opacity
  const hex = Math.round(opacity * 255).toString(16);
  return `${color}${hex.length === 1 ? "0" + hex : hex}`;
};
